import { styled } from '@mui/system';
import { Button, Typography } from '@mui/material';

export const StyledMain = styled('main')(({ theme }) => ({
  marginTop: -160,
  top: '50%',
  position: 'relative',
  width: 'auto',
  display: 'block', // Fix IE 11 issue.
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.up(400 + 8 * 3 * 2)]: {
    width: 400,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  zIndex: 10
}));

export const DivPaper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const MainBg = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: '#FFF',
  zIndex: 1
}));

export const CompanyImgCnt = styled('div')(() => ({
  height: 100,
  display: 'flex',
  alignItems: 'center'
}));

export const CompanyImgLogo = styled('img')(() => ({
  height: 100,
  maxWidth: 246
}));

export const StyledH5 = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(3)
}));

export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
  marginTop: theme.spacing()
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(3),
  justifyContent: 'space-between',
  '& > button': {
    alignSelf: 'center'
  }
}));

export const ForgotPasswordMain = styled('main')(({ theme }) => ({
  marginTop: -160,
  top: '50%',
  position: 'relative',
  width: 'auto',
  display: 'block', // Fix IE 11 issue.
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  [theme.breakpoints.up(400 + 8 * 3 * 2)]: {
    width: 400,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}));

export const ForgotPasswordText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'center',
  color: '#667'
}));

export const ForgotBtn = styled(Button)(() => ({
  color: '#667'
}));
